module.exports = __webpack_public_path__ + "static/img/trial0.bdba96ab.svg";